// extracted by mini-css-extract-plugin
module.exports = {"calendar__month":"Month_calendar__month__N8wv_","calendar__week":"Month_calendar__week___2MIM"};